import nhatmap from './image/837.jpg';
import adr from './image/img_index_02.png';
import wdn from './image/img_index_03.png';
import ioss from './image/img_index_04.png';
import maco from './image/img_index_05.png';
import pict from './image/index-img-07.webp';
import imgbckhead from './image/index-hero-01.webp';
import imggg from './image/index-img-05.webp';
import imgth from './image/index-img-03.svg';
import imgf from './image/index-img-04.svg';
import './App.css';
import { Col, Row } from 'antd';
// hellos
function App() {
  return (
    <div className="App">
      <div>
        <div className='header' style={{ backgroundImage: `url(${imgbckhead})`, minHeight: 700 }}>
          <Row style={{ maxHeight: "fit-content" }}>
            <Col span={12} style={{ alignSelf: "center" }}>
              <Row style={{ paddingTop: "10%" }}>
                <Col span={24}>
                  <span>
                    <h1>
                      NAKOMI 株式会社
                    </h1>
                  </span>
                </Col>
              </Row>
              <Row>
                <h1 style={{ color: "#FFFFFF", fontWeight: "bold", fontSize: "300%", paddingLeft: "10%" }}>
                  豊富な実績と、高セキュリティ/高品質の
                  法人向けWi-Fi環境構築サービス
                </h1>
              </Row>
            </Col>
          </Row>
        </div>
        <div>
          <Row>
            <Col span={24}>
              <h2 style={{ fontWeight: "bold", fontSize: "350%", position: "relative", padding: 20, borderBottom: "4px solid blue" }}>
                インターネットアクセス
              </h2>
            </Col>
          </Row>
          <Row>
            <Col span={10} style={{ paddingLeft: 30 }}>
              <h2 style={{ fontSize: "250%" }}>
                日本全国10万箇所以上。
              </h2>
              <h2 style={{ fontSize: "250%" }}>
                街中でも観光地でも、日本最高のWi-Fiサービスです。
              </h2>
              <h2 style={{ fontSize: "250%" }}>
                複数のプラットフォームとの互換性
              </h2>
              <Row>
                <Col span={12}>
                  <Row>
                    <img style={{ padding: 30 }} src={adr} alt="imggg" />
                    <h2 style={{ paddingTop: "10%" }}>
                      Android
                    </h2>
                  </Row>
                  <Row>
                    <img style={{ padding: 30 }} src={ioss} alt="imggg" />
                    <h2 style={{ paddingTop: "10%" }}>
                      Ios
                    </h2>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row>
                    <img style={{ padding: 30 }} src={wdn} alt="imggg" />
                    <h2 style={{ paddingTop: "10%" }}>
                      Windows
                    </h2>
                  </Row>
                  <Row>
                    <img style={{ padding: 30 }} src={maco} alt="imggg" />
                    <h2 style={{ paddingTop: "10%" }}>
                      Mac Os
                    </h2>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col span={14}>
              <span>
                <img style={{ maxHeight: 700, maxWidth: 800 }} src={nhatmap} alt="imggg" />
              </span>
            </Col>
          </Row>
        </div>
        <div style={{ minHeight: 800 }}>
          <div style={{ backgroundImage: `url(${imggg})`, minHeight: 400 }}>
          </div>
          <div>
            <Row>
              <Col span={12}>
                <div style={{ position: "relative", top: "-20%", left: "10%", backgroundColor: "#EEEEEE", borderRadius: 20, padding: "15% 0%", borderStyle: "inset" }}>
                  <h2 style={{ color: "#0099FF" }}>
                  Wi-Fi環境構築（法人向け）の手順とサービスの特長をご紹介
                  </h2>
                  <h2 style={{ color: "#0099FF" }}>
                    高セキュリティ/高品質で、圧倒的な構築実績を誇る
                  </h2>
                  <h3 style={{ padding: "0% 10%" }}>
                  NAMIKOでは、高セキュリティ・高品質・トータルサポートを誇る法人向けWi-Fiサービスを提供しております。
                  お客さまの業務効率化と情報セキュリティの強化を目指し、最新技術を用いた安全で高速なインターネット環境を構築します。
                  </h3>
                </div>
              </Col>
              <Col span={12}>
                <div style={{ margin: "5% 10%" }}>
                  <Row>
                    <Col span={8}>
                      <img style={{ padding: 30 }} src={imgth} alt="imggg" />
                    </Col>
                    <Col span={16}>
                      <h2>
                        旅行にも出張にも！<br />
                        短時間から使える公衆無線LANサービス
                      </h2>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={8}>
                      <img style={{ padding: 30 }} src={imgf} alt="imggg" />
                    </Col>
                    <Col span={16}>
                      <h2>
                        Wi-Fiや通信機器を日々利用するにあたって「知っていると役に立つこと」を、 Wi-Fiサービスを提供する通信事業者の目線から、テーマごとにわかりやすくご紹介。
                      </h2>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div>
          <Row>
            <Col span={24}>
              <h2 style={{ fontWeight: "bold", fontSize: "350%", position: "relative", padding: 20, borderBottom: "4px solid blue", borderBottomStyle: "inset" }}>
                サービスパッケージ
              </h2>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <div style={{ borderStyle: "inset", borderColor: "blue", borderWidth: "medium", padding: 20, margin: "5% 0% 10% 10%" }}>
                <Row>
                  <Col span={24} style={{ padding: "0px 20px" }}>
                    <h3 style={{ fontSize: "200%" }}>
                      6時間パス
                    </h3>
                    <h2 style={{ fontSize: "400%", lineHeight: "50%" }}>
                      ¥350
                    </h2>
                    <h3>
                      （税込）
                    </h3>
                    <h3>
                      初回ログインから6時間で有効期限が切れます。6時間以内であれば何度でもログイン可能です。
                    </h3>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col span={12}>
              <div style={{ borderStyle: "inset", borderColor: "blue", borderWidth: "medium", padding: 20, margin: "5% 10% 10% 0%" }}>
                <Row>
                  <Col span={24} style={{ padding: "0px 20px" }}>
                    <h3 style={{ fontSize: "200%" }}>
                      1日パス
                    </h3>
                    <h2 style={{ fontSize: "400%", lineHeight: "50%" }}>
                      ¥800
                    </h2>
                    <h3>
                      （税込）
                    </h3>
                    <h3>
                      初回ログインから24時間で有効期限が切れます。24時間以内であれば何度でもログインできます。
                    </h3>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <div style={{ borderStyle: "inset", borderColor: "blue", borderWidth: "medium", padding: 20, margin: "5% 0% 10% 10%" }}>
                <Row>
                  <Col span={24} style={{ padding: "0px 20px" }}>
                    <h3 style={{ fontSize: "200%" }}>
                      3日間パス
                    </h3>
                    <h2 style={{ fontSize: "400%", lineHeight: "50%" }}>
                      ¥1,500
                    </h2>
                    <h3>
                      （税込）
                    </h3>
                    <h3>
                      初回ログインから72時間以内にサービスが終了します。72時間以内であれば何度でもログインできます。
                    </h3>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col span={12}>
              <div style={{ borderStyle: "inset", borderColor: "blue", borderWidth: "medium", padding: 20, margin: "5% 10% 10% 0%" }}>
                <Row>
                  <Col span={24} style={{ padding: "0px 20px" }}>
                    <h3 style={{ fontSize: "200%" }}>
                      1週間パス
                    </h3>
                    <h2 style={{ fontSize: "400%", lineHeight: "50%" }}>
                      ¥2,000
                    </h2>
                    <h3>
                      （税込）
                    </h3>
                    <h3>
                      初回ログインから168時間で有効期限が切れます。168時間以内であれば何度でもログインできます
                    </h3>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
        <div >
          <Row>
            <Col span={12}>
              <img style={{ padding: 40, maxWidth: "90%" }} src={pict} alt="imggg" />
            </Col>
            <Col span={12} style={{ padding: "30px 20px" }}>
              <h2 style={{ fontSize: "150%" }}>
                個人向け会員制Wi-Fiサービス。月額200円から。
                どこでも安心・安全な Wi-Fi 体験を提供します。
              </h2>
              <h2 style={{ fontSize: "150%" }}>
                街中でも観光地でも、日本最高のWi-Fiサービスです。
              </h2>
              <h2 style={{ fontSize: "150%" }}>
                Wi-Fiなこみは, Wi-Fiの専門家がお届けする、高品質・高セキュリティな個人のお客様向けWi-Fiサービス。
              </h2>
            </Col>
          </Row>
        </div>
        <div className='company-info'>
          <Row>
            <Col span={24}>
              <h2 style={{ fontWeight: "bold", fontSize: "350%", position: "relative", padding: 20, borderBottom: "4px solid blue" }}>
                会社概要
              </h2>
            </Col>
          </Row>
          <div className='content-cf' style={{ margin: "0% 2% 5% 2%" }}>
            <Row>
              <Col span={8} style={{ display: "flex", alignItems: "flex-start", paddingLeft: "5%", borderStyle: "ridge", backgroundColor: "#EEEEEE" }}>
                <h3>
                  会社名
                </h3>
              </Col>
              <Col span={16} style={{display: "flex", alignItems: "flex-start", paddingLeft: "5%", borderStyle: "ridge" }}>
                <h3 style={{ fontWeight: "normal" }}>
                  NAKOMI 株式会社
                </h3>
              </Col>
            </Row>
            <Row>
              <Col span={8} style={{ display: "flex", alignItems: "flex-start", paddingLeft: "5%", borderStyle: "ridge", backgroundColor: "#EEEEEE" }}>
                <h3>
                  本社住所
                </h3>
              </Col>
              <Col span={16} style={{display: "flex", alignItems: "flex-start", paddingLeft: "5%", borderStyle: "ridge" }}>
                <h3 style={{ fontWeight: "normal" }}>
                    埼玉県川口市並木元町1-45黄金井ビル401
                </h3>
              </Col>
            </Row>
            <Row>
              <Col span={8} style={{ display: "flex", alignItems: "flex-start", paddingLeft: "5%", borderStyle: "ridge", backgroundColor: "#EEEEEE" }}>
                <h3>
                  資本
                </h3>
              </Col>
              <Col span={16} style={{display: "flex", alignItems: "flex-start", paddingLeft: "5%", borderStyle: "ridge" }}>
                <h3 style={{ fontWeight: "normal" }}>
                  1000 万
                </h3>
              </Col>
            </Row>
            <Row>
              <Col span={8} style={{ display: "flex", alignItems: "flex-start", paddingLeft: "5%", borderStyle: "ridge", backgroundColor: "#EEEEEE" }}>
                <h3>
                  取締役
                </h3>
              </Col>
              <Col span={16} style={{display: "flex", alignItems: "flex-start", paddingLeft: "5%", borderStyle: "ridge" }}>
                <h3 style={{ fontWeight: "normal" }}>
                  代表取締役社長：吉田ジョーンミチコ
                </h3>
              </Col>
            </Row>
            <Row>
              <Col span={8} style={{ display: "flex", alignItems: "flex-start", paddingLeft: "5%", borderStyle: "ridge", backgroundColor: "#EEEEEE" }}>
                <h3>
                  仕事
                </h3>
              </Col>
              <Col span={16} style={{display: "flex", alignItems: "flex-start", paddingLeft: "5%", borderStyle: "ridge" }}>
                <h3 style={{ fontWeight: "normal" }}>
                  Wifiサポート事業
                </h3>
              </Col>
            </Row>
          </div>
        </div>
        <div className='router-footer' style={{ backgroundColor: "#66FFFF" }} >
          <Row>
            <Col span={24}>
              <h2 style={{ fontWeight: "bold", fontSize: "250%", position: "relative", paddingTop: 10 }}>
                連絡先
              </h2>
              <h3>メールでのお問い合わせは英語または日本語でお願いします。電話でのお問い合わせは日本語のみとなります。
              </h3>
            </Col>
          </Row>
          <Row>
            <Col span={24} style={{ marginLeft: "40%", paddingBottom: "5%" }}>
              <Row>
                <h3>電子メール:&nbsp;</h3>
                <h3>namikokaisa@gmail.com</h3>
              </Row>
            </Col>
          </Row>
          <Row className='company' style={{ backgroundColor: "#3366FF" }}>
            <Col span={24}>
              <h5>
                Copyright ©2023 All rights reserved | NAKOMI 株式会社
              </h5>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default App;
